"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseLocaleProvider = /** @class */ (function () {
    function BaseLocaleProvider() {
        this.availableLocales = [];
    }
    Object.defineProperty(BaseLocaleProvider.prototype, "locales", {
        get: function () {
            return this.availableLocales;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLocaleProvider.prototype, "isInitialized", {
        get: function () {
            return this.availableLocales.length !== 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLocaleProvider.prototype, "language", {
        get: function () {
            return this.locale.split("-")[0];
        },
        enumerable: false,
        configurable: true
    });
    BaseLocaleProvider.prototype.setDefaultLocale = function (defaultLocale) {
        if (defaultLocale) {
            this.locale = defaultLocale;
        }
        else {
            this.locale = this.availableLocales[0];
        }
    };
    BaseLocaleProvider.prototype.initialize = function (availableLocales, defaultLocale) {
        if (availableLocales.length === 0) {
            throw new Error("You must specify at least one available locale");
        }
        this.availableLocales = availableLocales;
        this.setDefaultLocale(defaultLocale);
    };
    BaseLocaleProvider.prototype.changeLocale = function (locale) {
        if (!this.isInitialized) {
            throw new Error("You must initializace service first");
        }
        if (this.availableLocales.includes(locale)) {
            this.locale = locale;
            return true;
        }
        return false;
    };
    return BaseLocaleProvider;
}());
exports.default = BaseLocaleProvider;
